import React from "react";
import ChoiceMenu from "../ui/ChoiceMenu";
import ExpandMore from "@mui/icons-material/ExpandMore";
export default function ViewSelectDropdown({
  value,
  options,
  onChange,
  className = "",
}) {
  const match = options.find(
    (option) => (typeof option === "string" ? option : option.value) === value,
  );
  const label =
    typeof match === "string" ? match : match?.label || "Select view";
  return (
    <ChoiceMenu
      value={value}
      options={options}
      onChange={onChange}
      className={`view-select ${className}`.trim()}
      label={`View: ${label}`}
      variant="text"
      endIcon={<ExpandMore />}
    >
      {label}
    </ChoiceMenu>
  );
}
